import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import axios from "axios";
import { SessionManager, showAccessDeniedAlert, showTokenExpiredAlert } from "../../../utils";

export const sidebar = createAsyncThunk('sidebar', async ({ navigate }) => {

    try {
        const res = await axios({

            method: "GET",
            url: process.env.REACT_APP_API_URL + 'get_user_permission',
            headers: { "Content-Type": "application/json", "Authorization": SessionManager.getSession("user_token") }
        })
        return res
    } catch (error) {
        return error.response
    }
})


const sidebarSlice = createSlice({
    name: 'sidebar',
    initialState: {
        data: [],
    },
    extraReducers: (builder) => {
        builder.addCase(sidebar.fulfilled, (state, action) => {
            if (action?.payload?.status === 200) {
                state.data = action.payload.data.data;
            } else if (action?.payload?.status === 401) {
                showTokenExpiredAlert(action?.payload?.data?.message, action.meta.arg.navigate);
            } else if (action?.payload?.status === 403) {
                showAccessDeniedAlert(action.meta.arg.navigate)
            } else {
                state.data = [];
            }

        });
        builder.addCase(sidebar.rejected, (state, action) => {
            // console.log('reject', action)
        })
    }
})

export default sidebarSlice.reducer; 